import { adminServerInstance } from "../axios/instances";
import { 
    SPLIT_ORDERS,
    SPLIT_ORDERS_SUCCESS,
    SPLIT_ORDERS_FAIL,
    CREATE_SUB_BATCH_NEW,
    CREATE_SUB_BATCH_NEW_SUCCESS,
    CREATE_SUB_BATCH_NEW_FAIL,
    MARK_AS_REMOTE_ORDERS,
    MARK_AS_REMOTE_ORDERS_SUCCESS,
    MARK_AS_REMOTE_ORDERS_FAIL,
    FILTER_REMOTE_ORDERS,
    FILTER_REMOTE_ORDERS_SUCCESS,
    FILTER_REMOTE_ORDERS_FAIL,
    GET_BLIND_SCAN_BATCH_LIST,
    GET_BLIND_SCAN_BATCH_LIST_SUCCESS,
    GET_BLIND_SCAN_BATCH_LIST_FAIL,
    SET_BLIND_SCAN_BATCH_EFFECT,
    SET_BLIND_SCAN_BATCH_EFFECT_SUCCESS,
    SET_BLIND_SCAN_BATCH_EFFECT_FAIL
} from './types';

export function setBlindScanBatchEffect(warehouse, batchList){
    return function(dispatch){
        dispatch({type: SET_BLIND_SCAN_BATCH_EFFECT})
        return adminServerInstance.post(`/batchmanager/setblindscanbatcheffect?warehouse=${warehouse}&batch_list=${batchList}`)
        .then(({data}) => {
            dispatch({
                type: SET_BLIND_SCAN_BATCH_EFFECT_SUCCESS,
                payload: data.data
            })
            return Promise.resolve(data.data);
        }).catch(error => {
            dispatch({
                type: SET_BLIND_SCAN_BATCH_EFFECT_FAIL,
                payload: error
            })
            return Promise.reject(error);
        });
    }
}

export function getBlindScanBatchList(warehouse, batchList){
    return function(dispatch){
        dispatch({type: GET_BLIND_SCAN_BATCH_LIST})
        return adminServerInstance.get(`/batchmanager/getblindscanbatchlist?warehouse=${warehouse}&batch_list=${batchList}`)
        .then(({data}) => {
            dispatch({
                type: GET_BLIND_SCAN_BATCH_LIST_SUCCESS,
                payload: data.data
            })
            return Promise.resolve(data.data);
        }).catch(error => {
            dispatch({
                type: GET_BLIND_SCAN_BATCH_LIST_FAIL,
                payload: error
            })
            return Promise.reject(error);
        });
    }
}

export function filterRemoteOrders(warehouse, batchList){
    return function(dispatch){
        dispatch({type: FILTER_REMOTE_ORDERS})
        return adminServerInstance.get(`/business/filterremoteorders?warehouse=${warehouse}&batchlist=${batchList}`)
        .then(({data}) => {
            dispatch({
                type: FILTER_REMOTE_ORDERS_SUCCESS,
                payload: data
            })
            return Promise.resolve(data);
        }).catch(error => {
            dispatch({
                type: FILTER_REMOTE_ORDERS_FAIL,
                payload: error
            })
            return Promise.reject(error);
        });
    }
}

export function markAsRemoteOrders(sub_batch_nos){
    return function(dispatch){
        dispatch({type: MARK_AS_REMOTE_ORDERS})
        return adminServerInstance.post(`/map/markasremoteorders`,{
            sub_batch_nos: sub_batch_nos
        })
        .then(({data}) => {
            dispatch({
                type: MARK_AS_REMOTE_ORDERS_SUCCESS,
                payload: data
            })
            return Promise.resolve(data);
        }).catch(error => {
            dispatch({
                type: MARK_AS_REMOTE_ORDERS_FAIL,
                payload: error
            })
            return Promise.reject(error);
        });
    }
}

export function splitOrders(sub_batch_no, orderIds){
    return function(dispatch){
        dispatch({type: SPLIT_ORDERS})
        return adminServerInstance.post(`/map/splitorders`,{
            sub_batch_no: sub_batch_no,
            order_ids: orderIds
        })
        .then(({data}) => {
            dispatch({
                type: SPLIT_ORDERS_SUCCESS,
                payload: data
            })
            return Promise.resolve(data);
        }).catch(error => {
            dispatch({
                type: SPLIT_ORDERS_FAIL,
                payload: error
            })
            return Promise.reject(error);
        });
    }
}

export function createSubBatchNew(is_default, warehouse, batch_nos, states){
    return function(dispatch){
        dispatch({type: CREATE_SUB_BATCH_NEW})
        return adminServerInstance.post(`/cargo/createsubbatchnew`, {
            is_default: is_default,
            warehouse: warehouse,
            batch_nos: batch_nos,
            states: states,
            version: 1
        })
        .then(({data}) => {
            dispatch({
                type: CREATE_SUB_BATCH_NEW_SUCCESS,
                payload: data
            })
            return Promise.resolve(data);
        }).catch(error => {
            dispatch({
                type: CREATE_SUB_BATCH_NEW_FAIL,
                payload: error
            })
            return Promise.reject(error);
        });
    }
}